import React from 'react';
import Card from '../../../../muiComponents/Card';
import Tooltip from '../../../../muiComponents/Tooltip';
import DotIcon from '../../../components/DotIcon';
import Grid from '../../../../muiComponents/Grid';
import GridChild from '../../../../muiComponents/GridChild';
import { supplementCardGrid } from '../../../../utils/supplements/supplementUtils';
import Icon from '../../../../muiComponents/Icon';
import { commonIcons } from '../../../../utils/commonVariables/commonIcons';
import useTranslate from '../../../../customHooks/useTranslate';
import routes from '../../../../utils/commonVariables/routes';
import { formatDate } from '../../../../utils/formatDates';
import { useSearchParams } from '../../../../customHooks/useSearchParams';
import { IStopSaleListState } from '../../../../types/stopSale/stopSalesTypes';
import {
    gridSpacing10,
    gridSpacing20,
} from '../../../../utils/commonVariables/grid';

interface StopSaleCardProps {
    stopSale: IStopSaleListState;
}

const StopSaleCard = ({ stopSale }: StopSaleCardProps) => {
    const translate = useTranslate();

    const linkToHotel = routes.propertyDetail(stopSale.IdSupplierHotel);

    const { setSearchParam } = useSearchParams({ base64: true });
    const handleCardClick = (idStopSale: string) => {
        setSearchParam('id', idStopSale);
    };

    return (
        <Card
            className='padding20 flex-column gap-20 cursor-pointer'
            onClick={() => handleCardClick(stopSale.Id)}
        >
            <div className='flex flex-between border-color-bottom padding-bottom-8'>
                <h6 className='text-secondary-700 text-size-16'>
                    {stopSale.FromDate
                        ? formatDate(stopSale.FromDate)
                        : '--/--/----'}
                    {' - '}
                    {stopSale.ToDate
                        ? formatDate(stopSale.ToDate)
                        : '--/--/----'}
                </h6>
                <div className='flex gap-20 flex-align-center'>
                    <Tooltip
                        title={translate(
                            stopSale.Enabled ? 'enabled' : 'disabled'
                        )}
                    >
                        <span>
                            <DotIcon truthy={stopSale.Enabled} />
                        </span>
                    </Tooltip>
                </div>
            </div>

            <Grid columnSpacing={gridSpacing20} rowSpacing={gridSpacing10}>
                {stopSale.IdSupplierHotel ? (
                    <GridChild gridProps={supplementCardGrid}>
                        <Tooltip titleText={'hotel'} placement='top-start'>
                            <div className='flex gap-5'>
                                <Icon iconName={commonIcons.HOTEL} />

                                <Tooltip titleText='navigate_to_hotel_detail'>
                                    <p
                                        className=' link-onhover cursor-pointer'
                                        onClick={e => {
                                            e.stopPropagation();
                                            window.open(
                                                linkToHotel,
                                                linkToHotel
                                            );
                                        }}
                                    >
                                        {stopSale.SupplierHotel}
                                    </p>
                                </Tooltip>
                            </div>
                        </Tooltip>
                    </GridChild>
                ) : null}
                {stopSale.IdSupplierHotelRoomType ? (
                    <GridChild gridProps={supplementCardGrid}>
                        <Tooltip titleText={'room'} placement='top-start'>
                            <div className='flex gap-5'>
                                <Icon iconName={commonIcons.ROOM} />
                                <p>{stopSale.SupplierHotelRoomType}</p>
                            </div>
                        </Tooltip>
                    </GridChild>
                ) : null}{' '}
                {stopSale.IdSupplierHotelRatePlan ? (
                    <GridChild gridProps={supplementCardGrid}>
                        <Tooltip titleText={'rate_plan'} placement='top-start'>
                            <div className='flex gap-5'>
                                <Icon iconName={commonIcons.RATE_PLAN} />
                                <p>{stopSale.SupplierHotelRatePlan}</p>
                            </div>
                        </Tooltip>
                    </GridChild>
                ) : null}
                {stopSale.IdSupplierHotelMealPlan ? (
                    <GridChild gridProps={supplementCardGrid}>
                        <Tooltip titleText={'meal_plan'} placement='top-start'>
                            <div className='flex gap-5'>
                                <Icon iconName={commonIcons.MEAL_PLAN} />
                                <p>{stopSale.SupplierHotelMealPlan}</p>
                            </div>
                        </Tooltip>
                    </GridChild>
                ) : null}
            </Grid>
        </Card>
    );
};

export default StopSaleCard;
